// extracted by mini-css-extract-plugin
export default {"banner__wrapper":"banner_banner__wrapper__loyYg"};